export default "__VITE_ASSET__CmlsHZ5X__"